import { formatDate as formatDateSafe } from "../../../utils/date";

// Options for the optional fields (client types match the backend whitelist)
export const CLIENT_TYPES = ["Buyer", "Seller", "Tenant", "Landlord", "Investor"];
export const PARTNER_SPECIALIZATIONS = ["Broker", "Builder", "Interior Designer", "Legal", "Loan Agent", "Other"];
export const toSimpleOptions = (list) => list.map((value) => ({ value, label: value }));

// The backend answers "Already added: ..." when the same mobile is already in this account's list
export const isAlreadyAdded = (text) => typeof text === "string" && text.startsWith("Already added");

export const fullName = (person) =>
  [person?.first_name, person?.last_name].filter(Boolean).join(" ").trim() || "Unnamed";

export const initialsOf = (person) =>
  `${person?.first_name?.[0] || ""}${person?.last_name?.[0] || ""}`.toUpperCase() || "?";

export const formatDate = (value) => formatDateSafe(value, { fallback: "" });

export const locationOf = (person) => [person?.city_name, person?.state_name].filter(Boolean).join(", ");

// Mobile only shows the Edit / Delete actions of records that are still active
export const isActiveRecord = (person) => person?.active !== false;
